
/// STYLE ///
import './App.css';

/// COMPONENTS ///
import BoxComponent from './components/BoxComponent';


function App() {

  return (
    <>
      <BoxComponent />
    </>
  );
}

export default App;
